import { ISkillLevelData } from "./skillCreateMutation";
import { EntityTypes } from "../../EntityTypes";
import { IFrameworkResource } from "../../frameworks";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { ISkillResource } from "../types";

export type ISkillUpdateMutationParameters = {
    data: {
        officialTitle?: string;
        shortTitle?: string;
        skillLevel1?: ISkillLevelData;
        skillLevel2?: ISkillLevelData;
        skillLevel3?: ISkillLevelData;
        frameworks?: RelationalValue<IFrameworkResource>[];
        rank?: number;
    };
    skill: RelationalValue<ISkillResource>;
    locale?: string;
};

export type ISkillUpdateMutationResult = ISkillResource;

export const skillUpdateMutation: IApiMutationFunction<ISkillUpdateMutationParameters> = ({
    skill,
    data: { officialTitle, shortTitle, skillLevel1, skillLevel2, skillLevel3, frameworks, rank },
    locale,
}) => {
    return {
        method: "PUT",
        url: `/skills/${mapRelationalValue(skill)}`,
        data: {
            officialTitle,
            shortTitle,
            skillLevel1,
            skillLevel2,
            skillLevel3,
            frameworks: frameworks?.map(framework => mapRelationalValueAsIRI(EntityTypes.FRAMEWORK, framework)),
            rank,
        },
        headers: locale ? { "x-locale": locale } : undefined,
    };
};

export const useSkillUpdateMutation = createApiMutationHook<ISkillUpdateMutationParameters, ISkillUpdateMutationResult>(
    skillUpdateMutation,
);
